/* =====================================================================
 * BC click-events — micro-conversion dataLayer pushes
 *
 * Listens for: mailto / tel clicks, contact-form submits, Shopify Inbox
 * chat opens, Affirm BNPL clicks, Judge.me review submissions, scroll
 * depth milestones, customer login form submissions, collection-page
 * product tile clicks (select_item).
 *
 * GTM consumes via:
 *   - GA4 - Page+Search events (regex trigger 61) → routes to GA4
 *   - Per-platform Meta tags for the high-value events
 *
 * Why theme-side, not Customer Events sandbox: Shopify's CE pixel API
 * has no built-in mailto / tel / chat / scroll / Affirm / Judge.me /
 * generic-form-submit subscription. Theme-side delegation is canonical.
 *
 * Idempotent — safe to load multiple times.
 * ===================================================================== */
(function () {
  if (window.__bcClickEvents) return;
  window.__bcClickEvents = true;
  window.dataLayer = window.dataLayer || [];

  function uuid() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }

  function push(eventName, extra) {
    var payload = {
      event: eventName,
      event_id: uuid(),
      event_time: Math.floor(Date.now() / 1000),
      page_location: window.location.href,
      page_referrer: document.referrer || ''
    };
    if (extra) {
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
    }
    window.dataLayer.push(payload);
  }

  /* ------------------------------------------------------------------ */
  /* 1. Click delegation: mailto, tel, Shopify Inbox chat, Affirm       */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    // mailto / tel
    var a = t.closest && t.closest('a[href]');
    if (a) {
      var href = a.getAttribute('href') || '';
      var text = (a.textContent || '').trim().slice(0, 100);
      if (href.indexOf('mailto:') === 0) {
        push('email_click', { link_url: href, link_text: text, link_classes: a.className || '' });
        return;
      }
      if (href.indexOf('tel:') === 0) {
        push('phone_number_click', { link_url: href, link_text: text, link_classes: a.className || '' });
        return;
      }
    }

    // Shopify Inbox chat — button class varies; common selectors:
    //   button#shopify-chat, .shopify-chat-button, [data-testid="ShopifyChatLauncher"],
    //   shopify-chat-launcher (custom element), #shopify-chat-iframe (after open)
    var chat = t.closest && t.closest(
      '#shopify-chat, .shopify-chat-button, [data-testid="ShopifyChatLauncher"], shopify-chat-launcher, [aria-label*="chat" i][role="button"], button[aria-label*="message" i]'
    );
    if (chat) {
      push('chat_open', { chat_provider: 'shopify_inbox' });
      return;
    }

    // Affirm "as low as / see if you qualify" messaging click
    var affirm = t.closest && t.closest(
      '.affirm-as-low-as, .affirm-modal-trigger, [data-affirm], a[href*="affirm.com"]'
    );
    if (affirm) {
      // Pull the BNPL offer dollar amount from the rendered Affirm widget.
      // Affirm renders the per-month figure in nested spans; we grab the first
      // dollar amount in the trigger element's text and strip currency formatting.
      var offerText = (affirm.textContent || '').trim().slice(0, 200);
      var amountMatch = offerText.match(/\$\s?([0-9][0-9,]*(?:\.[0-9]+)?)/);
      var offerAmount = amountMatch ? parseFloat(amountMatch[1].replace(/,/g, '')) : null;
      var payload = { offer_text: offerText.slice(0, 100) };
      if (offerAmount !== null && !isNaN(offerAmount)) payload.affirm_offer_amount = offerAmount;
      push('affirm_offer_click', payload);
      return;
    }

    // select_item — collection grid product tile click.
    // Shopify Dawn uses .card-wrapper > a.full-unstyled-link inside .product-grid / .grid__item / .card.
    // We capture the href to derive item_id (from /products/:handle or query).
    var card = t.closest && t.closest('.product-grid .card-wrapper a, .grid__item .card a, [data-product-card] a, a.product-card');
    if (card) {
      var ph = (card.getAttribute('href') || '');
      var handle = (ph.match(/\/products\/([^/?#]+)/) || [])[1] || '';
      if (handle) {
        push('select_item', {
          item_handle: handle,
          item_url: ph,
          link_text: (card.textContent || '').trim().slice(0, 100)
        });
      }
      return;
    }
  }, true);

  /* ------------------------------------------------------------------ */
  /* 2. Form submits: contact form, customer login                      */
  /* ------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var id = (f.id || '').toLowerCase();
    var cls = (f.className || '').toLowerCase();
    var action = (f.getAttribute('action') || '').toLowerCase();
    var hay = id + ' ' + cls + ' ' + action;

    // Customer login (Shopify default form#customer_login or action=/account/login)
    if (/\b(customer_login|login)\b/.test(hay) && !/\b(register|reset|recover)\b/.test(hay)) {
      push('login', { form_id: f.id || '' });
      return;
    }

    // Contact-form
    var skipContact = /\b(product|cart|search|localization|currency|newsletter|customer_login|customer_register|reset_customer)\b/.test(hay);
    if (!skipContact && /\bcontact\b/.test(hay)) {
      push('contact_form_submit', {
        form_id: f.id || '',
        form_name: f.getAttribute('name') || '',
        form_action: f.getAttribute('action') || ''
      });
      return;
    }
  }, true);

  /* ------------------------------------------------------------------ */
  /* 3. Judge.me review submitted (custom event hook)                   */
  /* ------------------------------------------------------------------ */
  // Judge.me dispatches `jdgm-review-submitted` on the document after a
  // user successfully submits a review.
  document.addEventListener('jdgm-review-submitted', function (e) {
    var detail = e && e.detail || {};
    push('review_submit', {
      review_provider: 'judgeme',
      product_id: detail.product_id || '',
      rating: detail.rating || ''
    });
  });

  /* ------------------------------------------------------------------ */
  /* 4. Scroll depth — fire at 25 / 50 / 75 / 90% (max once each)       */
  /* ------------------------------------------------------------------ */
  (function () {
    var fired = {};
    var thresholds = [25, 50, 75, 90];
    var ticking = false;
    function checkScroll() {
      ticking = false;
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop || 0;
      var scrollHeight = (doc.scrollHeight || document.body.scrollHeight) - (doc.clientHeight || window.innerHeight);
      if (scrollHeight <= 0) return;
      var pct = Math.round((scrollTop / scrollHeight) * 100);
      for (var i = 0; i < thresholds.length; i++) {
        var t = thresholds[i];
        if (!fired[t] && pct >= t) {
          fired[t] = true;
          push('scroll', { percent_scrolled: t });
        }
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(checkScroll); ticking = true; }
    }, { passive: true });
  })();
})();
